import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { List, Button } from '@pella/sash-framework';
import { useGlobalConfig } from '../../../../hooks/use-global-config';
import { CTA } from '../../../';
import { useQuery } from '@apollo/client';
import { GET_PROMOS_BY_BRANCH } from '../../../../enums/graphql';

import BranchOfferText from '../../../common/branch-offer/branch-offer-text';
import BranchDisclaimerModal from '../../../common/branch-offer/branch-disclaimer-modal';

const BranchOfferCard = ({ branchID, className }) => {
	const { showroom: configData } = useGlobalConfig();
	const { data } = useQuery(GET_PROMOS_BY_BRANCH, { variables: { branchIDs: branchID }, skip: !branchID ? true : false });

	const [isOpen, setIsOpen] = useState(false);

	if (!data?.getPromotionsByBranchId?.[0]) return null;

	const onModalTriggerClick = (value) => setIsOpen(value);

	return (
		<div className={`branchOfferCard bg-black p-5 ${className || ''}`}>
			{data?.getPromotionsByBranchId?.[0] && (
				<div className='border border-white p-5 text-center'>
					<BranchOfferText offer={data.getPromotionsByBranchId[0]} />

					<List
						bullets='none'
						className='mt-4 flex flex-row flex-wrap max-md:space-y-3 md:justify-center md:space-x-4 xl:space-x-8'
					>
						{configData?.get_offer?.[0] && (
							<li className='flex-12/12 md:flex-none'>
								<CTA
									data={configData.get_offer[0]}
									className='text-white'
								/>
							</li>
						)}

						<li className='flex-12/12 md:flex-none'>
							<Button
								color='tertiary'
								className='text-white'
								onClick={() => onModalTriggerClick(true)}
							>
								{configData?.disclosure_modal}
							</Button>
						</li>
					</List>
				</div>
			)}

			<BranchDisclaimerModal
				isOpen={isOpen}
				onClose={() => onModalTriggerClick(false)}
				disclaimer={data.getPromotionsByBranchId[0]}
			/>
		</div>
	);
};

BranchOfferCard.propTypes = {
	branchID: PropTypes.string.isRequired,
	className: PropTypes.string,
};

export default BranchOfferCard;
